import { render } from "./DeliveredIcon.vue?vue&type=template&id=7ed3efc0&scoped=true&ts=true"
import script from "./DeliveredIcon.vue?vue&type=script&lang=ts"
export * from "./DeliveredIcon.vue?vue&type=script&lang=ts"

import "./DeliveredIcon.vue?vue&type=style&index=0&id=7ed3efc0&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed3efc0"]])

export default __exports__